const KEY = "ACTIVE_CHECKOUT";

/*
  checkout shape:
  {
    mode: "BUY_NOW" | "CART",
    items: [],
    address?: {},
    method?: string
  }
*/

export const setCheckout = (checkout) => {
  try {
    localStorage.setItem(KEY, JSON.stringify(checkout));
  } catch (e) {
    console.error("Error setting checkout:", e);
  }
};

export const getCheckout = () => {
  try {
    const data = localStorage.getItem(KEY);
    // console.log("Retrieved checkout data:", data);
    return data ? JSON.parse(data) : null;
  } catch (e) {
    console.error("Error getting checkout:", e);
    return null;
  }
};

export const clearCheckout = () => {
  localStorage.removeItem(KEY);
};

/* Backward compatibility */
export const setBuyNowProduct = (product) => {
  setCheckout({
    mode: "BUY_NOW",
    items: [product],
  });
};

export const getBuyNowProduct = () => {
  const checkout = getCheckout();
  return checkout?.mode === "BUY_NOW" ? checkout.items[0] : null;
};

export const clearBuyNowProduct = clearCheckout;
